<div id="ageJuncture" class="container">
    <div class="row" *ngIf="!this.FlagService.flagServiceObject[1]['offerJunctureFlag']">
        <div class="col-12 p-0">
            <div class="component-header __indicator">
                <h3 class="label mb-0">{{ 'junctures.age.header' | translate }}</h3>
            </div>
        </div>
<!--
        <ul class="list-group d-flex justify-content-between align-items-start p-0">
            <li class="list-group-item" *ngIf="this.availableAdultOffer">
                <a id="01" (click)="sendChoosenAgeGroup($event.currentTarget)">
                    <fa-icon class="faMale me-2" [icon]="faMale"></fa-icon>
                    <div class="ms-2 me-auto">
                        <h4 class="label mb-0">{{ 'junctures.age.adult.title' | translate }}</h4>
                        <span *ngIf="dataService.isKompakt()">{{ 'junctures.age.adult.kompakt' | translate }}</span>
                        <span *ngIf="!dataService.isKompakt()">{{ 'junctures.age.adult.notKompakt' | translate }}</span>
                    </div>
                </a>
            </li>
            <li class="list-group-item" *ngIf="this.availableChildrenOffer">
                <a id="02" (click)="sendChoosenAgeGroup($event.currentTarget)">
                    <fa-icon class="faChild me-2" [icon]="faChild"></fa-icon>
                    <div class="ms-2 me-auto">
                        <h4 class="label mb-0">{{ 'junctures.age.child.title' | translate }}</h4>
                        <span *ngIf="dataService.isKompakt()">{{ 'junctures.age.child.kompakt' | translate }}</span>
                        <span *ngIf="!dataService.isKompakt()">{{ 'junctures.age.child.notKompakt' | translate }}</span>
                    </div>
                </a>
            </li>
        </ul>
        -->
      <label class="form-label mt-4 pt-2">{{ 'junctures.age.birthDate' | translate }}</label>
      <div class="birth-year-selection">
        <select name="bYear" class="form-select birth-year" aria-label="Birth year select" [(ngModel)]="_birthYear" (ngModelChange)="birthInputChange()" required>
          <option *ngFor="let year of dataService.availableYears" value="{{ year }}">
            {{ year }}
          </option>
        </select>
        <select name="bMonth" class="form-select birth-month" aria-label="Birth month select" [(ngModel)]="_birthMonth" (ngModelChange)="birthInputChange()" required>
          <option *ngFor="let month of generalUtils.getMonths()" value="{{ month }}">
            {{ ('common.month.' + month) | translate }}
          </option>
        </select>
        <select name="bDay" class="form-select birth-day" aria-label="Birth day select" [(ngModel)]="_birthDay" (ngModelChange)="birthInputChange()" required>
          <option *ngFor="let day of generalUtils.getDays() | keyvalue" value="{{ day.key }}">
            {{ day.value }}
          </option>
        </select>
      </div>
      <div *ngIf="validationStarted">
        <div class="feedback invalid-feedback" *ngIf="!birthDateIsValid">{{ 'missing.age.invalidDate' | translate }}</div>
      </div>
      <div class="age-info">
        <div>
          <fa-icon class="age-info-icon" [icon]="faInfoCircle"></fa-icon>
        </div>
        <div class="age-info-text">
          {{ 'junctures.age.contractStartDate' | translate }}: {{ startDate }}<br />
          {{ 'missing.age.info1' | translate:{ insurance } }}<br />
          <ng-container *ngIf="!availableChildrenOffer && availableAdultOffer">
            {{ 'missing.age.info2' | translate:{ fromAge, toAge } }}
          </ng-container>
          <ng-container *ngIf="availableChildrenOffer && !availableAdultOffer">
            {{ 'missing.age.info3' | translate:{ fromAge: fromAge2, fromTime, toAge: toAge2 } }}
          </ng-container>
          <ng-container *ngIf="availableChildrenOffer && availableAdultOffer">
            {{ 'missing.age.info4' | translate:{ fromAge1: fromAge, fromTime, toAge1: toAge, fromAge2, toAge2 } }}
          </ng-container>
        </div>
      </div>
      <div class="age-error" *ngIf="birthDateIsValid && !hasOffer">
        {{ 'missing.age.noInsurance' | translate }}
      </div>
    </div>

    <div id="ageFeedback" class="row feedback-module {{'feedback-' + this.AgeGroupService.choosenAgeGroup[0].id}}"
         [ngClass]="{ 'no-pointer': !this.FlagService.flagServiceObject[1]['offerJunctureFlag'] }"
         *ngIf="this.FlagService.flagServiceObject[1]['offerJunctureFlag'] || hasOffer">
        <div class="d-flex p-0">
            <div class="w-100" (click)="this.FlagService.flagServiceObject[1]['offerJunctureFlag'] ? ageJunctureClick() : null">
                <fa-icon class="text-center ms-3 me-3" [icon]="faMale"></fa-icon>
                <div class="text">
                    <span class="top">
                      {{ AgeGroupService.getAgeChoicesArray(AgeGroupService.choosenAgeGroup[0].id).label }}
                    </span>
                  <br>
                    <span class="bottom" *ngIf="dataService.isKompakt()">
                      {{ AgeGroupService.getAgeChoicesArray(AgeGroupService.choosenAgeGroup[0].id).kompakt_detail }}
                    </span>
                    <span class="bottom" *ngIf="!dataService.isKompakt()">
                      {{ AgeGroupService.getAgeChoicesArray(AgeGroupService.choosenAgeGroup[0].id).detail }}
                    </span>
                </div>
            </div>
            <div class="button-container" *ngIf="!this.FlagService.flagServiceObject[1]['offerJunctureFlag']">
              <button type="button" (click)="sendChoosenAgeGroup(this.AgeGroupService.choosenAgeGroup[0].id)" class="btn btn-light float-end">{{ 'common.ok' | translate }}</button>
            </div>
<!--
            <div class="flex-shrink-1">
                <fa-icon class="faInfoCircle me-2" [icon]="faInfoCircle"></fa-icon>
            </div>
-->
        </div>
    </div>
</div>
